import {
  Products_API_URL,
  GetSiteUpdatedProducts_API_URL,
  GetProductsByPriceListCode_API_URL,
} from "./config";
import axiosApi from "../api/axiosInstance";

export const getProducts = async () => {
  const env_var = process.env.NODE_ENV;
  const myproducts = await axiosApi.get(Products_API_URL);

  // console.log(`[${env_var}] Fetched products:`, myproducts.data);

  if (myproducts.status !== 200) {
    throw new Error(`Failed to fetch products: ${myproducts.status}`);
  }

  // Normalize: if backend returns { data: [...] } vs [...]
  const data = myproducts.data?.data ?? myproducts.data;

  if (!Array.isArray(data)) {
    throw new Error("Unexpected products response format: expected an array");
  }

  return data;
};

export const getProductsByCustomerGroup = async () => {
  const products = await getProducts();

  let promoProductsResponse;
  try {
    promoProductsResponse = await axiosApi.get(GetSiteUpdatedProducts_API_URL, {
      skipUnauthorizedEvent: true, // ✅ added
    });
  } catch (err) {
    return products;
  }

  if (!promoProductsResponse || promoProductsResponse.status !== 200) {
    return products;
  }

  const promoProductsData = promoProductsResponse.data?.products ?? [];

  if (!Array.isArray(promoProductsData) || promoProductsData.length === 0) {
    return products;
  }

  const updatedProducts = products.map((product) => {
    const matchedProduct = promoProductsData.find(
      (p) => p.id == product.id.toString()
    );

    if (matchedProduct) {
      return {
        ...product,
        discount: 0,
        promoPrice: true,
        price: matchedProduct.price,
        actualprice: matchedProduct.actualprice ?? product.actualprice,
      };
    }

    return product;
  });

  return updatedProducts;
};

// get products by listCode
export const getProductsByPriceListCode = async (params) => {
  let { listCode } = params;
  // url="/api/v2/mosque/pricelist"
  const url = GetProductsByPriceListCode_API_URL;

  if (!listCode) {
    throw new Error("listCode is required");
  }

  if (process.env.NODE_ENV === "development") {
    // console.log(`Fetching products for listCode: ${listCode}`);
    listCode = process.env.REACT_APP_ZULAL_PRICE_LIST_CODE || listCode;
  } else {
    listCode = process.env.REACT_APP_ZULAL_PRICE_LIST_CODE || listCode;
  }

  try {
    const productsResponse = await axiosApi.get(url, {
      params: {
        listCode: listCode,
      },
    });

    return productsResponse.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};
